import { Pipe, PipeTransform } from '@angular/core';
import { UtilsProvider } from "../providers/utils-provider.service";


@Pipe({standalone: true,  name: 'dateClosest' })
export class DateClosestPipe implements PipeTransform {
    constructor(
        private _utils: UtilsProvider
    ) { }

    public transform(str: string, format = 'closest') {
        return this._utils.formatDate(str, format);
    }
}
